/** The Calls page's sections. Shared by the page and its route's `?view=`. */
export type CallsView = 'calls' | 'action-needed' | 'conferences';

export const CALLS_VIEWS: readonly CallsView[] = ['calls', 'action-needed', 'conferences'];

/**
 * What the page opens on.
 *
 * Action needed, not the call log: the queue is the only part of this page
 * that is work rather than history, and a missed call nobody rings back is
 * the thing this screen exists to prevent. Landing on the full call log put
 * the outstanding work one click away and, for most people, out of mind.
 *
 * Also what `?view=` omits, so the URL stays clean on the default and a link
 * to the log is explicit (`?view=calls`).
 */
export const DEFAULT_CALLS_VIEW: CallsView = 'action-needed';
